import { on } from 'delegated-events'
import ajax from '@common/ajax'

const pageItems = document.querySelector('.trees-items')
const form = document.querySelector('.trees-form')

on('submit', '.trees-form', async (e) => {
  e.preventDefault()

  const formData = new FormData(form)

  for (let [name, value] of Array.from(formData.entries())) {
    if (value === '') formData.delete(name)
  }

  const params = new URLSearchParams(formData).toString()
  const endpoint = new URL(form.action)
  endpoint.search = `?${params}`

  window.history.replaceState({}, '', endpoint.toString())

  form.classList.add('is-filtered')
  pageItems.classList.add('is-filtered-loading')

  const res = await ajax.get(endpoint).text()

  pageItems.innerHTML = res
  pageItems.classList.remove('is-filtered-loading')
})

on('click', '.trees-reset', (e) => {
  e.preventDefault()

  form.querySelectorAll('input').forEach((x) => (x.value = ''))

  if (form.requestSubmit) {
    form.requestSubmit()
  } else {
    form.dispatchEvent(new Event('submit'))
  }

  form.classList.remove('is-filtered')
})
